import type { SVGProps } from 'react';

type IconName =
  | 'scan'
  | 'cut'
  | 'grapple'
  | 'cargo'
  | 'timer'
  | 'warning'
  | 'map'
  | 'settings'
  | 'pause'
  | 'close'
  | 'power'
  | 'target'
  | 'arrow';

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

export function Icon({ name, ...props }: IconProps) {
  const common = {
    fill: 'none',
    stroke: 'currentColor',
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    strokeWidth: 1.8,
  };

  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" {...props}>
      <g {...common}>
        {name === 'scan' && (
          <>
            <path d="M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3" />
            <circle cx="12" cy="12" r="2" />
            <path d="M7.5 12a4.5 4.5 0 0 1 9 0M5 12a7 7 0 0 1 14 0" />
          </>
        )}
        {name === 'cut' && (
          <>
            <path d="m5 19 8-8M14.5 9.5l2.8-2.8M4 20l3.2-.8-2.4-2.4L4 20Z" />
            <path d="m15.7 4.5.8 1.7 1.8.3-1.3 1.3.3 1.8-1.6-.9-1.7.9.3-1.8-1.3-1.3 1.8-.3.7-1.7Z" />
          </>
        )}
        {name === 'grapple' && (
          <>
            <path d="M12 3v10M7 6l5-3 5 3M6 12c0 4 2 7 6 9 4-2 6-5 6-9M6 12h3M15 12h3" />
          </>
        )}
        {name === 'cargo' && (
          <>
            <path d="M4 8h16v11H4zM8 8V5h8v3M4 13h16M10 12v2h4v-2" />
          </>
        )}
        {name === 'timer' && (
          <>
            <circle cx="12" cy="13" r="8" />
            <path d="M9 3h6M12 5v2M12 13l3-3" />
          </>
        )}
        {name === 'warning' && (
          <>
            <path d="M12 3 2.8 20h18.4L12 3Z" />
            <path d="M12 9v5M12 17h.01" />
          </>
        )}
        {name === 'map' && (
          <>
            <path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3V6Z" />
            <path d="M9 3v15M15 6v15" />
          </>
        )}
        {name === 'settings' && (
          <>
            <circle cx="12" cy="12" r="3" />
            <path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.4-2.4 1a8 8 0 0 0-1.8-1L14.4 3h-4.8l-.4 3a8 8 0 0 0-1.8 1l-2.4-1-2 3.4L5.1 11a7 7 0 0 0 0 2L3 14.5l2 3.4 2.4-1a8 8 0 0 0 1.8 1l.4 3h4.8l.4-3a8 8 0 0 0 1.8-1l2.4 1 2-3.4-2.1-1.5a7 7 0 0 0 .1-1Z" />
          </>
        )}
        {name === 'pause' && <path d="M8 5v14M16 5v14" />}
        {name === 'close' && <path d="m6 6 12 12M18 6 6 18" />}
        {name === 'power' && <path d="M12 2v9M7.5 5.5a8 8 0 1 0 9 0" />}
        {name === 'target' && (
          <>
            <circle cx="12" cy="12" r="7" />
            <circle cx="12" cy="12" r="2.5" />
            <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
          </>
        )}
        {name === 'arrow' && <path d="m5 12 6 6M5 12l6-6M5 12h14" />}
      </g>
    </svg>
  );
}
